import { SessionType, type SessionTypeKey } from '@/stores/sessionType'

export enum SessionTier {
  Premium = 'premium',
  Traditional = 'traditional',
  Basic = 'basic'
}

/** Session type keys classified as Premium tier. */
const PREMIUM_KEYS: SessionTypeKey[] = [
  SessionType.EliteUnlimited,
  SessionType.ElitePlus,
  SessionType.Elite,
  SessionType.MostPopular
]

/** Session type keys classified as Traditional tier (including RS+ siblings). */
const TRADITIONAL_KEYS: SessionTypeKey[] = [
  SessionType.Legacy,
  SessionType.LegacyRoadshowPlus,
  SessionType.Standard,
  SessionType.StandardRoadshowPlus,
  SessionType.Simple,
  SessionType.SimpleRoadshowPlus,
  SessionType.BasicPlus,
  SessionType.BasicPlusRoadshowPlus,
  SessionType.BasicMax,
  SessionType.BasicMaxRoadshowPlus
]

/** Session type keys classified as Basic tier (including the RS+ sibling). */
const BASIC_KEYS: SessionTypeKey[] = [SessionType.Basic, SessionType.BasicRoadshowPlus]

/**
 * Classify a session type key into its pricing/feature tier.
 * Derives the tier directly from the key name.
 *
 * Returns null for unknown keys; callers should treat null as
 * premium (no upsells) for safety.
 */
export function getSessionTierByKey(key: SessionTypeKey): SessionTier | null {
  if (PREMIUM_KEYS.includes(key)) return SessionTier.Premium
  if (BASIC_KEYS.includes(key)) return SessionTier.Basic
  if (TRADITIONAL_KEYS.includes(key)) return SessionTier.Traditional
  return null
}
